import React from 'react';

import { MagicLinkSentViewShared } from '@liscio/common';

export interface MagicLinkSentViewProps {
  email: string;
  onBackToLogin: () => void;
}

/**
 * Authentication success confirmation rendered after a magic link request.
 * Visual style mirrors the light-theme client variant so the firm-side
 * V5 login flow keeps a consistent look across states.
 */
export const MagicLinkSentView = ({
  email,
  onBackToLogin,
}: MagicLinkSentViewProps) => {
  return <MagicLinkSentViewShared email={email} onBackToLogin={onBackToLogin} />;
};

export default MagicLinkSentView;
